import { useState, useMemo } from 'react';

export const useBlogPosts = (posts, isAdminLoggedIn) => {
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const POSTS_PER_PAGE = 10;

  // Memoize visible posts (filter drafts for non-admins)
  const visiblePosts = useMemo(() => {
    return posts.filter(p => p.status !== 'draft' || isAdminLoggedIn);
  }, [posts, isAdminLoggedIn]);

  // Memoize filtered posts based on category and search
  const filteredBlogPosts = useMemo(() => {
    const categoryFiltered = selectedFilter === 'All' 
      ? visiblePosts 
      : visiblePosts.filter(p => p.category === selectedFilter);
      
    if (searchQuery.trim() === '') return categoryFiltered;
    
    const lowerQuery = searchQuery.toLowerCase();
    return categoryFiltered.filter(p => 
      p.title?.toLowerCase().includes(lowerQuery) || 
      p.excerpt?.toLowerCase().includes(lowerQuery)
    );
  }, [visiblePosts, selectedFilter, searchQuery]);

  // Pagination
  const totalPages = Math.max(1, Math.ceil(filteredBlogPosts.length / POSTS_PER_PAGE));
  const currentBlogPosts = useMemo(() => {
    return filteredBlogPosts.slice((currentPage - 1) * POSTS_PER_PAGE, currentPage * POSTS_PER_PAGE);
  }, [filteredBlogPosts, currentPage]);

  const goToPage = (page) => {
    setCurrentPage(Math.max(1, Math.min(totalPages, page)));
  };

  const resetPagination = () => setCurrentPage(1);

  return {
    selectedFilter,
    setSelectedFilter,
    searchQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage: goToPage,
    resetPagination,
    totalPages,
    currentBlogPosts,
    filteredBlogPosts,
    visiblePosts
  };
};